
var winWidth   = $(window).width();
var winWidthSm = 992;
var headerId   = $('#js-header');


$(document).ready(function() {


  // // table_wrap
  // if ( document.getElementById('js-editor') != null ) {
  //   $('#js-editor table').each(function() {
  //     $(this).wrap('<div class="c-tblwrap"></div>');
  //   });
  // }


  // // tab
  // $('.js-tabbtn').each(function(){
  //   $('> li > a', this).on('click', function(){
  //     var tabHref   = $(this).attr('href');
  //     var clickWrap = $(this).closest('.js-tabbtn');
  //     var tabObj    = clickWrap.find('a');
  //     var contsObj  = clickWrap.next('.js-tabconts').children('div');

  //     tabObj.removeClass('is-act');
  //     $(this).addClass('is-act');

  //     contsObj.hide();
  //     $(tabHref).fadeIn();

  //     return false;
  //   }).eq(0).click();
  // });



  // slick
  imgCount = 0;
  $('#js-sld-kv').slick({
    fade: true,
    autoplay: true,
    autoplaySpeed: 6000,
    speed: 1500,
    cssEase: 'linear',
    arrows: false,
    dots: true,
    pauseOnFocus: false,
    pauseOnHover: false,
  });

  $('.js-sld-thumb').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1200,
    slidesToShow: 3,
    arrows: true,
    prevArrow: '<button class="slick-prev-cus slick-arrow" aria-label="Previous" type="button"></button>',
    nextArrow: '<button class="slick-next-cus slick-arrow" aria-label="Next" type="button"></button>',
    dots: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    responsive:[
      {
        breakpoint: 992,
        settings:{
          slidesToShow: 2,
          arrows: false,
          dots: true,
        }
      },
      {
        breakpoint: 768,
        settings:{
          slidesToShow: 2,
          arrows: false,
          dots: true,
        }
      },
    ]
  });

  $('#js-sld-room').slick({
    infinite: false,
    fade: true,
    autoplay: false,
    speed: 1000,
    cssEase: 'linear',
    arrows: false,
    dots: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    asNavFor:'#js-sld-room-nav',
  });
  $('#js-sld-room-nav').on('init', function(event, slick) {
    imgCount = slick.slideCount;
  }).slick({
    infinite: false,
    autoplay: false,
    speed: 1000,
    slidesToShow: 3,
    arrows: true,
    prevArrow: '<button class="slick-prev-cus slick-arrow" aria-label="Previous" type="button"></button>',
    nextArrow: '<button class="slick-next-cus slick-arrow" aria-label="Next" type="button"></button>',
    dots: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    asNavFor:'#js-sld-room',
    focusOnSelect: true,
  });
  function subSliderClass() {
    var winWidth   = $(window).width();
    if( imgCount > 3 ) {
      $('#js-sld-room-nav').removeClass('fixed');
    } else {
      $('#js-sld-room-nav').addClass('fixed');
    }
  }
  subSliderClass();
  $(window).on('resize', function() {
    subSliderClass();
  });



  // ajaxzip3
  $('#js-postal').keyup( function(event){
    AjaxZip3.zip2addr( this, '', 'contact_pref', 'contact_city' );
  });


  // cookie
  checkboxProp();
  roomVal();

  $('.js-cookie').on('change', function(){
    var checkVal  = $(this).val();
    var $cookie1 = $.cookie('check_room1');
    var $cookie2 = $.cookie('check_room2');
    var $cookie3 = $.cookie('check_room3');

    if ( $(this).prop('checked') ) {
      for (var i = 1; i <= 3; i++) {
        if ( !eval( '$cookie' + i ) ) {
          $.cookie('check_room' + i, checkVal, { expires: 7, path: '/' });
          eval( '$cookie' + i + '=' + checkVal + ';' );
          break;
        }
      }
    } else {
      for (var i = 1; i <= 3; i++) {
        if ( eval( '$cookie' + i + '==' + 'checkVal' ) ) {
          var deleteNum = i;
          deleteCookie( deleteNum );
          break;
        }
      }
    }

    checkboxProp();
  });

  $('.js-cookie-delete').on('click', function(){
    var $cookie1 = $.cookie('check_room1');
    var $cookie2 = $.cookie('check_room2');
    var $cookie3 = $.cookie('check_room3');
    var inputElm = $(this).parent().prev('.conts').children();
    var inputElmVal = inputElm.val();

    for (var i = 1; i <= 3; i++) {
      if ( eval( '$cookie' + i + '==' + 'inputElmVal' ) ) {
        var deleteNum = i;
        deleteCookie( deleteNum );
        break;
      }
    }

    inputElm.val('');
  });

  $('.js-cookie-single').on('click', function(){
    var btnVal   = $(this).val();
    var btnUrl   = $(this).data('url');
    var $cookie1 = $.cookie('check_room1');
    var $cookie2 = $.cookie('check_room2');
    var $cookie3 = $.cookie('check_room3');

    for (var i = 1; i <= 3; i++) {
      if ( !eval( '$cookie' + i ) ) {
        $.cookie('check_room' + i, btnVal, { expires: 7, path: '/' });
        eval( '$cookie' + i + '=' + btnVal + ';' );
        break;
      }
    }

    window.location.href = btnUrl;
  });

  // console.log($.cookie('check_room1'));
  // console.log($.cookie('check_room2'));
  // console.log($.cookie('check_room3'));
  // $.removeCookie('check_room1', { path: '/' });
  // $.removeCookie('check_room2', { path: '/' });
  // $.removeCookie('check_room3', { path: '/' });



  // form
  $('.js-form-cat').on('change', function(){
    var checkVal   = $('input:radio[name="contact_cat"]:checked').val();
    var otherInput = $('#js-form-cat-other');

    if ( checkVal == 'その他' ) {
      otherInput.prop('disabled', false);
    } else {
      otherInput.prop('disabled', true).val('');
    }
  }).change();

  $('.js-form-agree').on('change', function(){
    btnConfirm = $('.js-btn-confirm');
    if ( $(this).prop('checked') ) {
      btnConfirm.prop('disabled', false);
    } else {
      btnConfirm.prop('disabled', true);
    }
  }).change();

});


function checkboxProp() {
  var $cookie3 = $.cookie('check_room3');
  $('.js-cookie').each(function(){
    if ( !$cookie3 ) {
      if ( !$(this).prop('checked') ) {
        $(this).prop('disabled', false);
      }
    } else {
      if ( !$(this).prop('checked') ) {
        $(this).prop('disabled', true);
      }
    }
  });
}

function roomVal() {
  var $cookie1 = $.cookie('check_room1');
  var $cookie2 = $.cookie('check_room2');
  var $cookie3 = $.cookie('check_room3');

  if ( $('.mw_wp_form_input').length ) {
    for (var i = 1; i <= 3; i++) {
      if ( eval( '$cookie' + i ) ) {
        $('#js-cookie-room' + i).val( eval( '$cookie' + i ) );
      }
    }
  }
}

function deleteCookie( num ) {
  var $cookie2 = $.cookie('check_room2');
  var $cookie3 = $.cookie('check_room3');

  if ( num == 1 ) {

    if ( $cookie2 ) {
      $.cookie('check_room1', $cookie2, { expires: 7, path: '/' });
    } else {
      $.removeCookie('check_room1', { path: '/' });
    }
    if ( $cookie3 ) {
      $.cookie('check_room2', $cookie3, { expires: 7, path: '/' });
    } else {
      $.removeCookie('check_room2', { path: '/' });
    }

  } else if( num == 2 ) {

    if ( $cookie3 ) {
      $.cookie('check_room2', $cookie3, { expires: 7, path: '/' });
    } else {
      $.removeCookie('check_room2', { path: '/' });
    }

  }
  $.removeCookie('check_room3', { path: '/' });

}